import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Home } from 'lucide-react';

export default function ArtikelModerneMuslimischeWohnideen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Moderne muslimische Wohnideen für Ramadan & Eid</h1>
          <p className="text-lg text-white/80 leading-relaxed">Wie du dein Zuhause das ganze Jahr über stilvoll islamisch gestaltest.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Ein muslimisches Zuhause kann sowohl modern als auch spirituell sein. Hier findest du Ideen, wie du islamische Elemente elegant in deine Einrichtung integrierst – nicht nur zu Ramadan und Eid, sondern das ganze Jahr über.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Home className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Wandgestaltung</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Islamische Kalligraphie</h4>
                <p className="text-sm text-[#4B5563]">Ayat al-Kursi, Bismillah, die 99 Namen Allahs – als moderner Kunstdruck in schlichtem Rahmen. Schwarz-Weiß oder Gold auf Weiß.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Geometrische Muster</h4>
                <p className="text-sm text-[#4B5563]">Islamische Geometrie als Wandbild, Tapete oder selbst gestaltete Leinwand. Zeitlos und neutral.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Spiegel mit arabischem Rahmen</h4>
                <p className="text-sm text-[#4B5563]">Ornamentierte Rahmen bringen orientalisches Flair ohne aufdringlich zu sein.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Gebetsecke einrichten</h2>
            <p className="text-[#4B5563] mb-4">Ein ruhiger Ort für das Gebet ist das Herzstück eines muslimischen Zuhauses.</p>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Der perfekte Platz</h4>
                <p className="text-sm text-[#4B5563]">Eine ruhige Ecke, idealerweise Richtung Qibla. Abseits von Durchgangsbereichen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Essentials</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Schöner Gebetsteppich</li>
                  <li>• Quran auf einem Rehal (Ständer)</li>
                  <li>• Tasbih in einer dekorativen Schale</li>
                  <li>• Optional: Bakhoor/Räucherwerk</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Gestaltung</h4>
                <p className="text-sm text-[#4B5563]">Ein kleines Regal für Bücher, ein Kalligraphie-Bild darüber, sanfte Beleuchtung. Schlicht und einladend.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Wohnzimmer-Ideen</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Orientalische Laternen</h4>
                <p className="text-sm text-[#4B5563]">Marokkanische Laternen – nicht nur zu Ramadan! Als permanente Lichtquelle auf Regalen oder am Boden.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Kissen & Textilien</h4>
                <p className="text-sm text-[#4B5563]">Kissen mit geometrischen Mustern oder dezenter Kalligraphie. Hochwertige Stoffe in Erdtönen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Beistelltische</h4>
                <p className="text-sm text-[#4B5563]">Marokkanische Tablett-Tische in Gold oder Silber – praktisch und dekorativ.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Küche & Esszimmer</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Bismillah"-Wandbild</h4>
                <p className="text-sm text-[#4B5563]">Über dem Esstisch oder in der Küche – eine Erinnerung vor jeder Mahlzeit.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Teeservice</h4>
                <p className="text-sm text-[#4B5563]">Ein schönes marokkanisches oder türkisches Teeservice als Deko und für Gäste.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Dattel-Schale</h4>
                <p className="text-sm text-[#4B5563]">Eine dekorative Schale mit Datteln – immer bereit für Gäste und als Symbol für Gastfreundschaft.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Düfte & Atmosphäre</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Bakhoor & Oud</h4>
                <p className="text-sm text-[#4B5563]">Traditioneller Weihrauch – besonders zu besonderen Anlässen. Ein schönes Räuchergefäß ist auch ein Deko-Element.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Duftkerzen</h4>
                <p className="text-sm text-[#4B5563]">Oud, Rose, Amber, Sandelholz – orientalische Düfte für jeden Tag.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Diffuser</h4>
                <p className="text-sm text-[#4B5563]">Moderne Alternative: Elektrische Diffuser mit ätherischen Ölen.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Stil-Tipps</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Balance finden:</strong> Nicht jeder Raum braucht islamische Deko – Akzente reichen</li>
                <li><strong>Qualität vor Quantität:</strong> Wenige hochwertige Stücke statt vieler billiger</li>
                <li><strong>Modern kombinieren:</strong> Islamische Kunst passt zu skandinavischem Design!</li>
                <li><strong>Persönlich gestalten:</strong> Was für dich spirituell bedeutsam ist, gehört ins Zuhause</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Ein muslimisches Zuhause muss nicht traditionell oder überladen sein. Mit den richtigen Elementen schaffst du einen Raum, der modern, stilvoll und spirituell ist – das ganze Jahr über, nicht nur zu Ramadan und Eid.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/minimalistische-eid-deko" className="text-[#4A5D4F] hover:underline">→ Minimalistische Eid Dekoration</Link></li>
              <li><Link to="/ratgeber/eid-deko-ideen" className="text-[#4A5D4F] hover:underline">→ Eid Deko Ideen für Zuhause</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
